import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Chevron — forward navigation affordance on rows. */
export function ChevronIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="m9.5 6 6 6-6 6" />
    </PortalIcon>
  );
}
